import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';

// Импорт переводов
import en from './locales/en.json';
import ru from './locales/ru.json';
import es from './locales/es.json';

// Получение языка из cookies или браузера
const getLanguage = () => {
  const savedLanguage = Cookies.get('language');
  if (savedLanguage && ['ru', 'en', 'es'].includes(savedLanguage)) {
    return savedLanguage;
  }
  
  const browserLanguage = navigator.language.split('-')[0];
  return ['ru', 'en', 'es'].includes(browserLanguage) ? browserLanguage : 'ru';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      es: { translation: es }
    },
    lng: getLanguage(),
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['cookie', 'navigator'],
      caches: ['cookie']
    }
  });

// Функция для смены языка
export const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
  Cookies.set('language', lang, { expires: 365 });
  // Также отправляем на backend если пользователь авторизован
  if (localStorage.getItem('token')) {
    // API call to update user language preference
  }
};

export default i18n;
